/*
 * @Author: LeeHuiXian
 * @version:
 * @Date: 2020-04-13 15:27:43
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-07-16 17:16:14
 * @FilePath: /goldenSalesMobile/src/main.js
 * @Description:
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// console.log("%c store.state ", "background-image:color:transparent;color:yellow;font-size:2em");
// console.log(store.state);
// localStorage.setItem('originStore', JSON.stringify(store.state));
import "./assets/icons"; // icon
import "./permission"; // permission control
import "normalize.css/normalize.css";
import vueQr from "vue-qr";
import JsBarcode from "./components/JsBarcode";
import "u/directives";
import "normalize.css/normalize.css";
import "@/styles/gStyle.scss";
import "@/styles/quill.bubble.css";
import "@/styles/quill.core.css";
import "@/styles/quill.snow.css";
import "@/assets/iconfont/iconfont.css";
import "@/utils/auth";
import { $http } from "@/utils/http";
import * as $pub from "@/utils/gFunc";
Vue.prototype.$pub = window.$pub = $pub;

window.$store = store;

Vue.prototype.$http = window.$http = $http;

import "@/utils/doNotChange/importGlobalComp";

// 注册全局组件
Vue.component("vue-qr", vueQr);
Vue.component("JsBarcode", JsBarcode);

Vue.config.productionTip = false;
// 组件自动化全局注册
const requireComponent = require.context(
  // 其组件目录的相对路径
  "./components/pageConfigCom",
  // 是否查询其子目录
  true,
  // 匹配基础组件文件名的正则表达式
  /\.vue$/
);
requireComponent.keys().forEach((fileName) => {
  // 获取组件配置
  const componentConfig = requireComponent(fileName);
  // 全局注册组件
  Vue.component(
    componentConfig.default.name, // 此处的name,是组件属性定义的name
    // 如果这个组件选项是通过 `export default` 导出的，
    // 那么就会优先使用 `.default`，
    // 否则回退到使用模块的根。
    componentConfig.default
  );
});
import Vant from "vant";
import "vant/lib/index.css";
import "vant/lib/index.less";
Vue.use(Vant);
import { Toast, Lazyload } from "vant";

Vue.use(Toast);
Vue.use(Lazyload);

import wxConfig from "@/utils/wxConfig";
Vue.prototype.$wxConfig = wxConfig;

import * as filters from "@/utils/filters";
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

import VConsole from "vconsole";
// let vConsole = "";
// if (process.env.NODE_ENV !== "production") {
//   vConsole = new VConsole();
// }

// 引入计算加减乘除的函数, 防止出现浮点数精度问题
import * as calcFunc from "@/utils/calcFunc";
Vue.prototype.$calc = calcFunc;

// 将本地变量缓存起来, 用来监听本地变量的改变。

Vue.prototype.resetSetItem = (key, newVal) => {
  if (key === "allStoreList") {
    // 创建一个StorageEvent事件
    let newStorageEvent = document.createEvent("StorageEvent");
    const storage = {
      setItem: (k, val) => {
        localStorage.setItem(k, val);
        // 初始化创建的事件
        newStorageEvent.initStorageEvent(
          "setItem",
          false,
          false,
          k,
          null,
          val,
          null,
          null
        );
        // 派发对象
        window.dispatchEvent(newStorageEvent);
      },
    };
    return storage.setItem(key, newVal);
  }
};

// 全局公共变量
const gData = {
  isDev:
    process.env.NODE_ENV === "development" || process.env.NODE_ENV === "uat",
  defaultImg: require("@/assets/images/defaultPic1.png"),
  wethatImg: require("@/assets/images/Headportrait@2x.png"),
};

function queryParams() {
  console.log(`*****<<<  我到底是122s2  >>>*****`);
}

const $u = {
  queryParams: queryParams,
};

// 忽略微信开放标签的未知组件警告
Vue.config.ignoredElements = [
  'wx-open-launch-weapp',
  'wx-open-launch-weapp-template'  // 如果有 template 标签也需要
];

let vm = new Vue({
  router,
  data: gData,
  store,
  render: (h) => h(App),
}).$mount("#app");
